module.exports = __webpack_public_path__ + "af22e754e512989c7a9e5940ba4051da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/princess.png
// module id = 771
// module chunks = 0